import React, { FC } from 'react';
import { SVGTooltipProps } from '@utils';
import { SvgWithTooltip } from '../SvgWithTooltip';

export const Projector: FC<SVGTooltipProps> = ({ onClick, divClassName, tooltip }) => (
  <SvgWithTooltip 
    onClick={onClick}
    divClassName={divClassName}  
    tooltip={tooltip}
  >  
    <svg
      xmlns="http://www.w3.org/2000/svg" 
      x="0px" 
      y="0px"
	    viewBox="0 0 294.777 294.777" 
    >
      <path d="M11.338,0v294.777h272.102V0H11.338z M56.688,272.102H34.013v-22.675h22.675V272.102z M56.688,226.751H34.013v-22.675
        h22.675V226.751z M56.688,181.401H34.013v-22.675h22.675V181.401z M56.688,136.051H34.013v-22.675h22.675V136.051z
        M56.688,90.701H34.013V68.025h22.675V90.701z M56.688,45.35H34.013V22.675h22.675V45.35z M215.414,272.102H79.363V158.726
        h136.051V272.102z M215.414,136.051H79.363V22.675h136.051V136.051z M260.764,272.102h-22.675v-22.675h22.675V272.102z
        M260.764,226.751h-22.675v-22.675h22.675V226.751z M260.764,181.401h-22.675v-22.675h22.675V181.401z M260.764,136.051h-22.675
        v-22.675h22.675V136.051z M260.764,90.701h-22.675V68.025h22.675V90.701z M260.764,45.35h-22.675V22.675h22.675V45.35z"
      />
    </svg>
  </SvgWithTooltip>
);
